import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  private readonly storageKey = 'selectedLanguage';

  setLanguage(lang: string) {
    localStorage.setItem(this.storageKey, lang);
  }

  getLanguage(): string {
    return localStorage.getItem(this.storageKey) || 'en';
  }
}
